export default {
  brandTitle: {
    en: `
      One last step left<br />
      choose your {gender, select, female {perfume} male {cologne}}
    `,
  },
  only: {
    en: 'Only',
  },
  left: {
    en: 'Left',
  },
  youHave: {
    en: `
      You have <span class="brandColor">12 hours</span> to add your first
      {gender, select, female {perfume} male {cologne}}&nbsp;to&nbsp;the&nbsp;queue&nbsp;before&nbsp;it’s<br />
      packed and shipped or leave your queue
      empty to&nbsp;get&nbsp;a&nbsp;cologne&nbsp;of&nbsp;the month.
    `,
  },
}
